module.exports = __webpack_public_path__ + "static/media/Circo2025_04.ab37557d.webp";